import { Info } from "lucide-react";
import { Popover, PopoverTrigger, PopoverContent } from "@/components/ui/popover";

// Tik-/klik-vriendelijke uitleg-popover (werkt ook op tablet & telefoon).
export const InfoTip = ({ text, testid }) => (
  <Popover>
    <PopoverTrigger asChild>
      <button type="button" data-testid={testid} onClick={(e) => e.stopPropagation()}
        className="inline-flex items-center text-brand-ink/40 hover:text-brand-violet transition-colors cursor-pointer align-middle" aria-label="Uitleg">
        <Info className="w-4 h-4" strokeWidth={2.5} />
      </button>
    </PopoverTrigger>
    <PopoverContent align="start" className="brutal border-2 border-brand-ink bg-white rounded-xl w-72 text-sm font-medium text-brand-ink leading-snug" data-testid={testid ? `${testid}-content` : undefined}>
      {text}
    </PopoverContent>
  </Popover>
);
